export const defaultTelegramMessageModel = () => ({
  audience_type: 'shop',
  recipient_ids: [],
  title: '',
  content: '',
  image: null,
  remove_image: false
})

export const buildTelegramMessageFormData = (model, action, scheduledAt = '') => {
  const data = new FormData()

  data.append('action', action)
  data.append('audience_type', model.audience_type)
  model.recipient_ids.forEach(id => data.append('recipient_ids[]', id))
  data.append('title', model.title)
  data.append('content', model.content)

  if (model.image) data.append('image', model.image)
  if (model.remove_image) data.append('remove_image', 1)
  if (scheduledAt) data.append('scheduled_at', scheduledAt)

  return data
}

export const draftToTelegramMessageModel = draft => ({
  audience_type: draft.audience_type || 'shop',
  recipient_ids: draft.audience_type === 'all'
    ? []
    : (draft.recipients || []).map(recipient => recipient.recipient_id),
  title: draft.title || '',
  content: draft.content || '',
  image: null,
  remove_image: false
})
